import {Box} from '@mui/material';

import {IMAGES} from '@/constants/images';

export const PaymentLinkBrands = () => (
  <Box className="payment-link-brands-container">
    <img
      src={IMAGES.ZERO_FEES.src}
      width={IMAGES.ZERO_FEES.width}
      height={IMAGES.ZERO_FEES.height}
    />
    <img
      src={IMAGES.APP_RATING.src}
      width={IMAGES.APP_RATING.width}
      height={IMAGES.APP_RATING.height}
    />
    <img
      src={IMAGES.SUPPORT.src}
      width={IMAGES.SUPPORT.width}
      height={IMAGES.SUPPORT.height}
    />
  </Box>
);
